<template>
  <div id="MWarehouseSetting" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">R</span>establecer</div>
        <div class="col-3 t-r f22 pr3"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 bb1" @click="reset_on('clients')">
        <div class="col-12 bg-color-white pl5 pr5 pt10 pb10">
            <div class="col-10 pl10">
              Clientes
            </div>
            <div class="col-2 color-muted t-r pr5">
              <i class="iconfont icon-31shuaxin f22"></i>
            </div>
        </div>
      </div>
      <div class="col-12 bb1" @click="reset_on('products')">
        <div class="col-12 bg-color-white pl5 pr5 pt10 pb10">
            <div class="col-10 pl10">
              Productos
            </div>
            <div class="col-2 color-muted t-r pr5">
              <i class="iconfont icon-31shuaxin f22"></i>
            </div>
        </div>
      </div>
      <div class="col-12 bb1" @click="reset_on('warehouses')">
        <div class="col-12 bg-color-white pl5 pr5 pt10 pb10">
            <div class="col-10 pl10">
              Almacenes
            </div>
            <div class="col-2 color-muted t-r pr5">
              <i class="iconfont icon-31shuaxin f22"></i>
            </div>
        </div>
      </div>
      <div class="col-12 bb1" @click="reset_on('sales')">
        <div class="col-12 bg-color-white pl5 pr5 pt10 pb10">
            <div class="col-10 pl10">
              Ventas
            </div>
            <div class="col-2 color-muted t-r pr5">
              <i class="iconfont icon-31shuaxin f22"></i>
            </div>
        </div>
      </div>
      <div class="col-12 bb1" @click="reset_on('other')">
        <div class="col-12 bg-color-white pl5 pr5 pt10 pb10">
            <div class="col-10 pl10">
              Otros
            </div>
            <div class="col-2 color-muted t-r pr5">
              <i class="iconfont icon-31shuaxin f22"></i>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MWarehouseSetting',
  data () {
    return {
      data_list: [],
    }
  },
  created: function () {
  },
  methods: {
    reset_on(type) {
      let post_data = {};
      post_data.type = type;
      this.post(this.api_url + 'manage/reset_data', post_data).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/Reset.vue